module.exports = __webpack_public_path__ + "media/2.42ea160b.mp3";